import { inject, Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { BankIdAuthenticateResultModel, PatientAuthenticateResultModel, PatientLoginInput, PatientTokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
// import { LocalStorageService } from '@shared/utils/local-storage.service';
import { TokenService } from 'abp-ng2-module';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private patientTokenAuthService = inject(PatientTokenAuthServiceProxy);
  private tokenService = inject(TokenService);

  login(patientLoginInput: PatientLoginInput): Observable<boolean> {
    return this.patientTokenAuthService.authenticate(patientLoginInput).pipe(
      tap((result) => {
        this.processLoginResult(result);
      }),
      map(result => !!result.accessToken),
      catchError(() => of(false))
    );
  }

  processBankIdLoginResult(result: BankIdAuthenticateResultModel) {
    this.processLoginResult(result);
  }

  processLoginResult(loginResultModel: PatientAuthenticateResultModel) {
    //this.tokenService.setToken(loginResultModel.accessToken!);
    const params = new URLSearchParams({
      token: loginResultModel.accessToken!,
      encryptedToken: loginResultModel.encryptedAccessToken!,
      redirect: '/dashboard-messages'
    });
    const url = `${AppConsts.appBaseUrl}/external-login?${params.toString()}`;
    window.open(url, '_blank');
  }

  logout() {
    this.tokenService.clearToken();
    //new LocalStorageService().removeItem(AppConsts.authorization.encryptedAuthTokenName, () => { });
    //location.reload();
  }
}
